import React from "react";
import { Box, Grid, Typography, TextField, MenuItem, Select } from "@mui/material";

interface FormControlConfig {
  id: string;
  type: "text" | "checkbox" | "dropdown";
  label: string;
  name: string;
  sm: number;
  options?: string[];
}

interface CardSection {
  id: string;
  title: string;
  controls: FormControlConfig[];
}

const FormPreview = ({ structure }: { structure: CardSection[] }) => {
  return (
    <Box>
      {structure.map((card) => (
        <Box key={card.id} sx={{ border: "1px solid #ccc", p: 2, mb: 3, borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom>
            {card.title}
          </Typography>
          <Grid container spacing={2}>
            {card.controls.map((ctrl) => (
              <Grid key={ctrl.id} item sm={ctrl.sm}>
                <Box>
                  <Typography variant="subtitle2">{ctrl.label}</Typography>
                  {ctrl.type === "text" && <TextField fullWidth size="small" />}
                  {ctrl.type === "checkbox" && (
                    <label>
                      <input type="checkbox" /> {ctrl.name}
                    </label>
                  )}
                  {ctrl.type === "dropdown" && (
                    <Select fullWidth size="small" defaultValue="">
                      {ctrl.options?.map((opt, idx) => (
                        <MenuItem key={idx} value={opt}>
                          {opt}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default FormPreview;
